module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [(_vm.$route.name === 'main-dashboard') ? _c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadBuildings
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.buildings,
      "disabled": _vm.buildings.length === 0,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadRooms
    },
    model: {
      value: (_vm.buildingId),
      callback: function($$v) {
        _vm.buildingId = $$v
      },
      expression: "buildingId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.rooms,
      "item-text": "name",
      "item-value": "id",
      "disabled": _vm.rooms.length === 0,
      "hide-details": "",
      "label": "Todas las habitaciones",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterById
    },
    model: {
      value: (_vm.roomId),
      callback: function($$v) {
        _vm.roomId = $$v
      },
      expression: "roomId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "body-border-bottom": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "my-1": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "append-icon-cb": _vm.toggleIconStartDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.onDateFilter
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeEndIcon
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "append-icon-cb": _vm.toggleIconEndDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.onDateFilter
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "my-1": "",
      "text-xs-right": ""
    }
  }, [_c('filters-by-time', {
    attrs: {
      "loading": _vm.loading,
      "value": _vm.value
    },
    on: {
      "apply-filter": _vm.onDateFilter
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "divider-rows",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "divider1",
    attrs: {
      "md6": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-items-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default mb-0 mr-3"
  }, [_vm._v("Habitaciones")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "oval-select mr-2",
    attrs: {
      "items": _vm.roomCleaningTypes,
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo de limpieza",
      "single-line": "",
      "hide-details": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterType
    },
    model: {
      value: (_vm.roomTypeId),
      callback: function($$v) {
        _vm.roomTypeId = $$v
      },
      expression: "roomTypeId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "oval-select",
    attrs: {
      "items": _vm.statusTypes,
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo de estado",
      "single-line": "",
      "hide-details": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterStatusType
    },
    model: {
      value: (_vm.statusTypeId),
      callback: function($$v) {
        _vm.statusTypeId = $$v
      },
      expression: "statusTypeId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "text-xs-right": ""
    }
  }, [(_vm.roomsSelected.length > 0) ? _c('button', {
    staticClass: "oval-button cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "oval-button ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.roomsSelected.length === 0
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEditar\n\t\t\t\t\t\t")])])], 1), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('v-layout', {
      key: state.id,
      staticClass: "text-xs-left",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md12": ""
      }
    }, [_c('div', {
      staticClass: "label-status"
    }, [_c('h5', [_c('router-link', {
      attrs: {
        "to": ("/dashboard/state/1/" + (state.name))
      }
    }, [_vm._v(_vm._s(state.name))])], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(state.rooms.length) + " habitaciones")])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md12": ""
      }
    }, _vm._l((state.rooms), function(room) {
      return _c('room-status', {
        key: room.id,
        attrs: {
          "background-color": room.color_state,
          "clean-state": room.clean_state,
          "number": room.number,
          "code": room.code_roomtype,
          "status-icon-img": room.icon_url,
          "room": room,
          "label-for": ("room-" + (room.id)),
          "extra-state": room.extra_state,
          "show-circle": true,
          "name": room.name
        },
        on: {
          "on-room-selected": _vm.roomIsSelected
        }
      })
    }))], 1)
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider2",
    attrs: {
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Estados")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "summary-container",
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, _vm._l((_vm.summaryStates), function(summaryState) {
    return _c('div', {
      key: summaryState.id
    }, [_c('div', {
      staticClass: "summary",
      style: (("border-color: " + (summaryState.color_state) + "; color: " + (summaryState.color_state) + ";"))
    }, [_c('p', [_vm._v(_vm._s(summaryState.quantity))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'housemaids-by-state',
          params: {
            stateId: summaryState.id,
            stateName: summaryState.name_state
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(summaryState.name_state) + "\n\t\t\t\t\t\t")])], 1)
  })), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Mucamas")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('div', {
    staticClass: "label-status mb-1"
  }, [_c('h5', [_vm._v("Nombre")]), _vm._v(" "), _c('h5', [_vm._v("Habitación")]), _vm._v(" "), _c('h5', [_vm._v("Calificación")])])]), _vm._v(" "), _vm._l((_vm.housemaids), function(maid) {
    return _c('v-layout', {
      key: maid.id,
      staticClass: "report-maid pl-0 ml-1",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md4": "",
        "text-xs-left": ""
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'housemaids-profile',
          params: {
            id: maid.id
          }
        }
      }
    }, [_vm._v(_vm._s(maid.name) + " " + _vm._s(maid.lastname))])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "score-ball",
      style: (("background-color: " + (maid.color_state)))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": "",
        "text-xs-right": ""
      }
    }, [_c('span', [_vm._v(_vm._s(maid.room_assigned))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "alerts pl-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Alertas")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "summary-container",
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, _vm._l((_vm.summaryAlerts), function(summaryAlert) {
    return _c('div', {
      key: summaryAlert.id
    }, [_c('div', {
      staticClass: "summary",
      style: (("border-color: " + (summaryAlert.color_alert) + "; color: " + (summaryAlert.color_alert) + ";"))
    }, [_c('p', [_vm._v(_vm._s(summaryAlert.quantity))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: summaryAlert.routerName
        }
      }
    }, [_vm._v(_vm._s(summaryAlert.name_alert))])], 1)
  })), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Actividades - Real time")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "realtime-content"
  }, [_c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/59.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": "",
      "pl-4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMaria Chiappe\n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("cambió de estado")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("En curso")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("Almuerzo")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar red"
  }), _vm._v(" "), _c('h6', {
    staticClass: "mb-0"
  }, [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar blue"
  }), _vm._v(" "), _c('h6', {
    staticClass: "mb-0"
  }, [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am\n\t\t\t\t\t\t\t\t\t\t")])])], 1)], 1)], 1)], 1)])], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "685",
      "content-class": "modal-dashboard"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\tCambiar de estado\n\t\t\t\t"), _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = false
      }
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Habitaciones seleccionadas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "mt-2": ""
    }
  }, _vm._l((_vm.roomsSelected), function(roomSelected) {
    return _c('room-status', {
      key: roomSelected.id,
      attrs: {
        "background-color": roomSelected.color_state,
        "clean-state": roomSelected.clean_state,
        "number": roomSelected.number,
        "code": roomSelected.code_roomtype,
        "status-icon-img": roomSelected.icon_url,
        "room": roomSelected,
        "label-for": ("room-selected-" + (roomSelected.id)),
        "extra-state": roomSelected.extra_state,
        "show-circle": true,
        "name": roomSelected.name,
        "is-added": roomSelected.isAdded,
        "room-id": roomSelected.id,
        "state-code": roomSelected.code_state
      },
      on: {
        "on-room-removed": _vm.deleteRoomAdded
      }
    })
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Define el estado de las habitaciones")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "mt-2": ""
    }
  }, _vm._l((_vm.statusTypes), function(roomState) {
    return (roomState.id) ? _c('room-status', {
      key: roomState.id,
      attrs: {
        "background-color": roomState.color_state,
        "status-icon-img": roomState.icon_url,
        "name": roomState.code_state,
        "room": roomState,
        "label-for": ("room-state-" + (roomState.id)),
        "name-state": roomState.name
      },
      on: {
        "on-room-selected": _vm.stateToChange
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-save mr-3 mb-2",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.editRoomStates
    }
  }, [_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6672461e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/dashboard/Dashboard.vue
// module id = 1655
// module chunks = 48